import DepsService from 'services/dependencies';

const CONTEXT = 'dashboard';

const fetchTopVltGames = (retailerId) => {
  const { url } = DepsService.rest.widgets.topVltGames;
  const queryParams = {};
  const urlParams = { retailerId };

  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);
};

export default {
  fetchTopVltGames,
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/resources/top-vlt-games.api.js